export class ApiApplicationSearchConstants {
    static PROPERTY_VALUATION_ENDPOINT = "PropertyValuationValuationBlock";
    static TOWN_PLANNING_ENDPOINT = "TownPlanning";
    static GAUTAIN_ENDPOINT = "Gautrain";
    static STREET_NAMING_ENDPOINT = "StreetNaming";
    static INFORMAL_TRADE_ENDPOINT = "InformalTrading";
    static ADVERTISING_ENDPOINT = "Advertising";
    static ELECTRICAL_CONNECTION_ENDPOINT = "ElectricalConnection";
    static CEMETERY_ENDPOINT = "Cemetery";
    static WAYLEAVE_ENDPOINT = "Wayleave";
    static MONDI_ENDPOINT = "Mondi";
    static BUILDING_PLANS_ENDPOINT = "BuildingPlans";
    static PROPERTY_AND_LEASE_ENDPOINT = "PropertyAndLease";
    static EHMS_ENDPOINT = "EhApplication";
    static DEMOLITION_MANAGEMENT_ENDPOINT = "DemolitionManagement";
    static TRAINING_MODULE_ENDPOINT = "TrainingModule";
    static ZONING_CERTIFICATE_ENDPOINT = "ZoningCertificate";
    static RATES_CERTIFICATE_ENDPOINT = "RatesCertificate";
    static BUSINESS_LICENCE_ENDPOINT = "BusinessLicence";
    static FUNCTION_GET_USERS_FOR_MODULE = "GetUsers";
    static FUNCTION_GET_TOWNPLANNERS = "GetTownPlanners";
    static FUNCTION_GET_APPLICATIONS_BY_USER = "GetApplicationsByUser";
    static FUNCTION_GET_A_APPLICATIONS_BY_USER = "GetAApplicationsByUser";
    static FUNCTION_GET_IT_APPLICATIONS_BY_USER = "GetITApplicationsByUser";
    static FUNCTION_GET_SN_APPLICATIONS_BY_USER = "GetSnApplicationsByUser";
    static FUNCTION_GET_PV_APPLICATIONS_BY_USER = "GetPvApplicationsByUser";
    static FUNCTION_GET_EH_APPLICATIONS_BY_USER = "GetEhApplicationsByUser";
    static FUNCTION_GET_TP_APPLICATIONS_BY_USER = "GetTpApplicationsByUser";
    static FUNCTION_GET_GT_APPLICATIONS_BY_USER = "GetGtApplicationsByUser";
    static FUNCTION_GET_BP_APPLICATIONS_BY_USER = "GetBpApplicationsByUser";
    static FUNCTION_GET_PL_APPLICATIONS_BY_USER = "GetPlApplicationsByUser";
    static FUNCTION_GET_CM_APPLICATIONS_BY_USER = "GetCmApplicationsByUser";
    static FUNCTION_GET_W_APPLICATIONS_BY_USER = "GetWApplicationsByUser";
    static FUNCTION_GET_DM_APPLICATIONS_BY_USER = "GetDmApplicationsByUser";
    static FUNCTION_GET_ZC_APPLICATIONS_BY_USER = "GetZcApplicationsByUser";
    static FUNCTION_GET_TM_APPLICATIONS_BY_USER = "GetTmApplicationsByUser";
    static FUNCTION_GET_RC_APPLICATIONS_BY_USER = "GetRcApplicationsByUser";
    static FUNCTION_GET_BL_APPLICATIONS_BY_USER = "GetBlApplicationsByUser";
    static FUNCTION_GET_EC_APPLICATIONS_BY_USER = "GetEcApplicationsByUser";
    static FUNCTION_GET_MND_APPLICATIONS_BY_USER = "GetMndApplicationsByUser";
    static FUNCTION_GET_APPLICATIONS_CREATED_BY_USER = "GetApplicationsCreatedByUser";
    static FUNCTION_GET_MND_APPLICATIONS_CREATED_BY_USER = "GetMndApplicationsCreatedByUser";
    static FUNCTION_GET_A_APPLICATIONS_CREATED_BY_USER = "GetAApplicationsCreatedByUser";
    static FUNCTION_GET_IT_APPLICATIONS_CREATED_BY_USER = "GetITApplicationsCreatedByUser";
    static FUNCTION_GET_SN_APPLICATIONS_CREATED_BY_USER = "GetSnApplicationsCreatedByUser";
    static FUNCTION_GET_PV_APPLICATIONS_CREATED_BY_USER = "GetPvApplicationsCreatedByUser";
    static FUNCTION_GET_EH_APPLICATIONS_CREATED_BY_USER = "GetEhApplicationsCreatedByUser";
    static FUNCTION_GET_TP_APPLICATIONS_CREATED_BY_USER = "GetTpApplicationsCreatedByUser";
    static FUNCTION_GET_GT_APPLICATIONS_CREATED_BY_USER = "GetGtApplicationsCreatedByUser";
    static FUNCTION_GET_BP_APPLICATIONS_CREATED_BY_USER = "GetBpApplicationsCreatedByUser";
    static FUNCTION_GET_PL_APPLICATIONS_CREATED_BY_USER = "GetPlApplicationsCreatedByUser";
    static FUNCTION_GET_CM_APPLICATIONS_CREATED_BY_USER = "GetCmApplicationsCreatedByUser";
    static FUNCTION_GET_W_APPLICATIONS_CREATED_BY_USER = "GetWApplicationsCreatedByUser";
    static FUNCTION_GET_DM_APPLICATIONS_CREATED_BY_USER = "GetDmApplicationsCreatedByUser";
    static FUNCTION_GET_ZC_APPLICATIONS_CREATED_BY_USER = "GetZcApplicationsCreatedByUser";
    static FUNCTION_GET_TM_APPLICATIONS_CREATED_BY_USER = "GetTmApplicationsCreatedByUser";
    static FUNCTION_GET_RC_APPLICATIONS_CREATED_BY_USER = "GetRcApplicationsCreatedByUser";
    static FUNCTION_GET_BL_APPLICATIONS_CREATED_BY_USER = "GetBlApplicationsCreatedByUser";
    static FUNCTION_GET_EC_APPLICATIONS_CREATED_BY_USER = "GetEcApplicationsCreatedByUser";
    static FUNCTION_GET_APPLICATIONS_BY_RESPONSIBLEPERSON = "GetApplicationsByResponsiblePerson";
    static FUNCTION_GET_A_APPLICATIONS_BY_RESPONSIBLEPERSON = "GetAApplicationsByResponsiblePerson";
    static FUNCTION_GET_IT_APPLICATIONS_BY_RESPONSIBLEPERSON = "GetITApplicationsByResponsiblePerson";
    static FUNCTION_GET_SN_APPLICATIONS_BY_RESPONSIBLEPERSON = "GetSnApplicationsByResponsiblePerson";
    static FUNCTION_GET_PV_APPLICATIONS_BY_RESPONSIBLEPERSON = "GetPvApplicationsByResponsiblePerson";
    static FUNCTION_GET_EH_APPLICATIONS_BY_RESPONSIBLEPERSON = "GetEhApplicationsByResponsiblePerson";
    static FUNCTION_GET_TP_APPLICATIONS_BY_RESPONSIBLEPERSON = "GetTpApplicationsByResponsiblePerson";
    static FUNCTION_GET_GT_APPLICATIONS_BY_RESPONSIBLEPERSON = "GetGtApplicationsByResponsiblePerson";
    static FUNCTION_GET_BP_APPLICATIONS_BY_RESPONSIBLEPERSON = "GetBpApplicationsByResponsiblePerson";
    static FUNCTION_GET_PL_APPLICATIONS_BY_RESPONSIBLEPERSON = "GetPlApplicationsByResponsiblePerson";
    static FUNCTION_GET_CM_APPLICATIONS_BY_RESPONSIBLEPERSON = "GetCmApplicationsByResponsiblePerson";
    static FUNCTION_GET_W_APPLICATIONS_BY_RESPONSIBLEPERSON = "GetWApplicationsByResponsiblePerson";
    static FUNCTION_GET_DM_APPLICATIONS_BY_RESPONSIBLEPERSON = "GetDmApplicationsByResponsiblePerson";
    static FUNCTION_GET_ZC_APPLICATIONS_BY_RESPONSIBLEPERSON = "GetZcApplicationsByResponsiblePerson";
    static FUNCTION_GET_TM_APPLICATIONS_BY_RESPONSIBLEPERSON = "GetTmApplicationsByResponsiblePerson";
    static FUNCTION_GET_RC_APPLICATIONS_BY_RESPONSIBLEPERSON = "GetRcApplicationsByResponsiblePerson";
    static FUNCTION_GET_BL_APPLICATIONS_BY_RESPONSIBLEPERSON = "GetBlApplicationsByResponsiblePerson";
    static FUNCTION_GET_EC_APPLICATIONS_BY_RESPONSIBLEPERSON = "GetEcApplicationsByResponsiblePerson";
    static FUNCTION_GET_MND_APPLICATIONS_BY_RESPONSIBLEPERSON = "GetMndApplicationsByResponsiblePerson";
    static FUNCTION_GET_CM_APPLICATIONS_WITH_FAMILIES = "GetCmApplicationsWithFamilies";
    static FUNCTION_GET_CM_APPLICATIONS_WITH_GRAVE = "GetCmApplicationsWithGrave";
    static FUNCTION_GET_PL_APPLICATIONS_WITH_GROUPS = "GetPlApplicationsWithGroups";
}
